import Vue from 'vue'
import store from './store'
import router from './router'
import App from './components/App'
import Element from 'element-ui'
import Cookies from 'js-cookie'
import 'element-ui/lib/theme-chalk/index.css';

import axios from 'axios'
Vue.prototype.$ajax=axios

import qs from 'qs'
Vue.prototype.$qs=qs

Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
});
new Vue({
  router,
  store,
  template: '<App/>',
  components: { App }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js